import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SoundproofRoomIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SoundproofRoomIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M8.08502 15.6703C8.24958 15.6703 8.4141 15.6075 8.53968 15.4819C10.4596 13.562 10.4596 10.438 8.53968 8.51807C8.28856 8.26695 7.88149 8.26695 7.63037 8.51807C7.37929 8.76915 7.37929 9.17626 7.63037 9.42734C9.04895 10.8459 9.04895 13.1541 7.63037 14.5726C7.22414 14.9789 7.51737 15.6703 8.08502 15.6703Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.19632 13.661C6.36088 13.661 6.5254 13.5982 6.65093 13.4727C7.46299 12.6606 7.46299 11.3394 6.65093 10.5273C6.39985 10.2762 5.99274 10.2762 5.74166 10.5273C5.49054 10.7784 5.49054 11.1855 5.74166 11.4366C6.05229 11.7473 6.05229 12.2528 5.74166 12.5634C5.33531 12.9698 5.62878 13.661 6.19632 13.661Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.69323 16.8097C9.28688 17.216 9.58035 17.9073 10.1479 17.9073C10.3124 17.9073 10.477 17.8445 10.6025 17.7189C13.7632 14.5583 13.7636 9.44221 10.6025 6.28112C10.3514 6.03 9.94434 6.03 9.69326 6.28112C9.44214 6.5322 9.44214 6.93931 9.69326 7.19039C12.3452 9.84245 12.3453 14.1576 9.69323 16.8097Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.0783 20.68H20.8372V2.67708C20.8372 2.322 20.5493 2.03412 20.1942 2.03412H17.1401C16.9336 2.03412 16.7397 2.1333 16.6188 2.30071L15.9457 3.23301C15.3806 4.01574 15.3806 5.06754 15.9457 5.85031C16.1858 6.1828 16.1858 6.62966 15.9457 6.96215C15.3806 7.74492 15.3806 8.79672 15.9457 9.57945C16.1858 9.91198 16.1858 10.3588 15.9457 10.6913C15.3806 11.4741 15.3806 12.5259 15.9457 13.3086C16.1858 13.6411 16.1858 14.088 15.9457 14.4205C15.3806 15.2032 15.3806 16.255 15.9457 17.0378C16.1858 17.3703 16.1858 17.8171 15.9457 18.1496C15.4013 18.9038 15.3816 19.9075 15.8863 20.6799H4.36122C4.00614 20.6799 3.71826 20.9678 3.71826 21.3229C3.71826 21.6779 4.00615 21.9658 4.36122 21.9658H21.0783C21.4333 21.9658 21.7212 21.6779 21.7212 21.3229C21.7212 20.9678 21.4333 20.68 21.0783 20.68ZM16.9883 16.2851C16.7482 15.9526 16.7482 15.5058 16.9883 15.1733C17.5534 14.3905 17.5534 13.3387 16.9883 12.556C16.7482 12.2235 16.7482 11.7767 16.9883 11.4441C17.5534 10.6614 17.5534 9.6096 16.9883 8.82683C16.7482 8.49434 16.7482 8.04748 16.9883 7.71499C17.5534 6.93222 17.5534 5.88042 16.9883 5.09769C16.7482 4.76516 16.7482 4.31834 16.9883 3.98585L17.4689 3.32006H19.5512V20.661L17.467 20.6774L16.9882 20.0143C16.7482 19.6819 16.7482 19.235 16.9882 18.9025C17.5534 18.1198 17.5534 17.0679 16.9883 16.2851Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SoundproofRoomIcon;
